export const ADDRESS_VALIDATION_CHOICE = 'ADDRESS_VALIDATION_CHOICE';
export const ADDRESS_VALIDATION_INVALID_FIELDS = 'ADDRESS_VALIDATION_INVALID_FIELDS';
export const ADDRESS_VALIDATION_RECOMMENDED_FIELDS = 'ADDRESS_VALIDATION_RECOMMENDED_FIELDS';
export const ADDRESS_VALIDATION_CHOICE_RESET = 'ADDRESS_VALIDATION_CHOICE_RESET';
